// extracted by mini-css-extract-plugin
export default {"removeButton":"deleteButton_removeButton__DmHC4"};